module.exports = __webpack_public_path__ + "static/media/52491596_2452964918112018_2328485363833634816_o.9fbcce83.jpg";